module.exports = __webpack_public_path__ + "static/media/BG_PDJ_Training.19189ff0.jpg";